__turbopack_context__.v({
  "section": "product-carousel-module__8VuuWW__section",
});
